import { ready, onShopifySectionLoad } from './utils/readyinit';
import { initSwiper, initSwiperMobile } from './components/swiper';
import initAccordion from './components/accordion';
import initLazyloadVideo from './utils/lazyloadVideo';
import initNavigation from './sections/header/navigation';
import initTransparentHeader from './sections/header/header';
import initCustomDropdowns from './components/custom-dropdowns';
import initAtcForm from './components/atcForm';
import initProductWarrantyAtcModal from './components/product-warranty-atc-modal';
import initFeaturedMedia from './sections/featured-media';
import initSearch from './sections/header/search';
import initTabbedTiles from './sections/tabbed-tiles';
import initFeaturedArticles from './sections/featured-articles';
import initFeaturedPartners from './sections/featured-partners';
import initTabbedAccordions from './sections/tabbed-accordions';
import initSubscriptionTiles from './sections/subscription-options';
import { initVatDisplay } from './utils/vatDisplay';
import initQuickBuy from './components/quickBuy';
import initTrustpilotProductReviews from './components/trustpilot-product-reviews';
import initTrustpilotProductQuestions from './components/trustpilot-product-questions';
import initContactForm from './components/contact-form';
import initContactFormSuccess from './components/contact-form-success';
import {
  recordLastCollectionFromUrl,
  recordLastProductContext,
  applyRecentCollectionBreadcrumb,
  applyCartBreadcrumbs,
} from './utils/browseCollectionContext';
import initRadioHireController from './sections/radio-hire-controller';
import initRadioHireProgress from './sections/radio-hire-progress';
import initStepLength from './sections/step-length';
import initStepQuantity from './sections/step-quantity';
import initStepAccessories from './sections/step-accessories';
import initStepReview from './sections/step-review';
import initQuoteForm from './sections/quote-form';

ready(() => {
  recordLastCollectionFromUrl();
  recordLastProductContext();
  applyRecentCollectionBreadcrumb();
  applyCartBreadcrumbs();
  initSwiper();
  initSwiperMobile();
  initCustomDropdowns();
  initTransparentHeader();
  initSearch();
  initNavigation();
  initAccordion();
  initLazyloadVideo();
  initAtcForm();
  initProductWarrantyAtcModal();
  initFeaturedMedia();
  initTabbedTiles();
  initFeaturedArticles();
  initFeaturedPartners();
  initTabbedAccordions();
  initSubscriptionTiles();
  initVatDisplay();
  initQuickBuy();
  initRadioHireController();
  initRadioHireProgress();
  initStepLength();
  initStepQuantity();
  initStepAccessories();
  initStepReview();
  initQuoteForm();
  initTrustpilotProductReviews();
  initTrustpilotProductQuestions();
  initContactForm();
  initContactFormSuccess();
});

onShopifySectionLoad(() => {
  recordLastCollectionFromUrl();
  recordLastProductContext();
  applyRecentCollectionBreadcrumb();
  applyCartBreadcrumbs();
  initSwiper();
  initSwiperMobile();
  initCustomDropdowns();
  initTransparentHeader();
  initSearch();
  initNavigation();
  initLazyloadVideo();
  initAtcForm();
  initProductWarrantyAtcModal();
  initFeaturedMedia();
  initTabbedTiles();
  initFeaturedArticles();
  initFeaturedPartners();
  initTabbedAccordions();
  initSubscriptionTiles();
  initVatDisplay();
  initQuickBuy();
  initRadioHireController();
  initRadioHireProgress();
  initStepLength();
  initStepQuantity();
  initStepAccessories();
  initStepReview();
  initQuoteForm();
  initTrustpilotProductReviews();
  initTrustpilotProductQuestions();
  initContactForm();
  initContactFormSuccess();
});
